import React from 'react';
import SeoHead from '../components/SeoHead';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';

const ProcessPage = () => (
  <>
    <SeoHead
      title="Our process"
      description="Discover. Design. Build. Ship. The four-phase process THINKINGWORLD uses on every engagement — predictable, transparent, low-drama."
      path="/process"
    />
    <header className="page-header">
      <div className="container">
        <span className="section-eyebrow">Process</span>
        <h1>How we work — predictable, transparent, low-drama.</h1>
        <p>
          A clear four-phase engagement so you always know where the project is
          and what is next.
        </p>
      </div>
    </header>
    <Process />
    <Testimonials />
  </>
);

export default ProcessPage;
